import PATHS, { USER_SETTINGS_DIALOGS } from 'constants/paths';

/** Central place for On Go free-plan limits and user-facing copy. */
export const ON_GO_ACCESS = {
  freeDailyExerciseLimit: 5,
  freeMaxQueueSize: 5,
  premiumSubscribePath: `${PATHS.USER_SETTINGS}/${USER_SETTINGS_DIALOGS.SUBSCRIBE}`,
  copy: {
    dashboard: {
      premiumBadge: '⭐ Premium',
    },
    entryModal: {
      beforeLink: 'Darmowy plan oferuje tylko 5 zadan dziennie, ',
      linkText: 'wykup dostęp premium',
      afterLink: ' aby uzyskać nielimitowany dostęp',
      closeButton: 'Rozumiem',
    },
    summary: {
      limitReachedMessage:
        'Osiągnąłeś dzienny limit 5 zadań w darmowym planie. Wykup dostęp premium, aby uzyskać nielimitowany dostęp.',
      dashboardButton: 'Wróć do pulpitu',
      newSessionButton: 'Nowa sesja',
      closingSession: 'Zamykamy sesję…',
    },
    initialize: {
      queueSizeHelper: 'Od 1 do 5 zadań',
      queueSizeMinError: 'Minimum 1 zadanie',
      queueSizeMaxError: 'Maksimum 5 zadań',
      queueSizeIntegerError: 'Podaj liczbę całkowitą',
    },
  },
} as const;
